import {BASE_ADMIN_API, fetchAPI} from '@/services/api';
import type {ResponsePage} from '@/services/page.interface';

export interface AuditCertificatePageBO {
    pageSize: number;
    pageNumber: number;
    pageType: number;
    auditorEnglishName?: string;
    accountingFirmName?: string;
    pcNumber?: string;
    isValid?: number;
}

export interface AuditCertificateBO {
    id?: number;
    auditorEnglishName?: string;
    accountingFirmName?: string;
    accountingFirmChineseName?: string;
    auditorSignName?: string;
    pcNumber?: string;
    auditorAddress?: string;
    auditorChineseAddress?: string;
    auditorFaxNumber?: string;
    auditorTelRepNumber?: string;
    auditorTelBankConfNumber?: string;
    auditorBrNumber?: string;
    certificateUrl?: string;
    isValid?: number;
}

export interface AuditCertificateVO {
    id: number;
    auditorEnglishName?: string;
    accountingFirmName?: string;
    accountingFirmChineseName?: string;
    auditorSignName?: string;
    pcNumber?: string;
    auditorAddress?: string;
    auditorChineseAddress?: string;
    auditorFaxNumber?: string;
    auditorTelRepNumber?: string;
    auditorTelBankConfNumber?: string;
    auditorBrNumber?: string;
    certificateUrl?: string;
    isValid?: number;
    /** 0=active, 1=soft-deleted */
    isDel?: number;
}

const base = `${BASE_ADMIN_API}/audit-certificate`;

export async function getById(id: number) {
    return fetchAPI<AuditCertificateVO>(`${base}/get?id=${id}`, {method: 'GET'});
}

export async function queryPage(pageBO: AuditCertificatePageBO) {
    return fetchAPI<ResponsePage<AuditCertificateVO>>(`${base}/queryPage`, {
        method: 'POST',
        body: JSON.stringify(pageBO),
    });
}

export async function querySelectionList() {
    return fetchAPI<AuditCertificateVO[]>(`${base}/querySelectionList`, {method: 'POST'});
}

export async function create(bo: AuditCertificateBO) {
    return fetchAPI<AuditCertificateVO>(`${base}/create`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

export async function update(id: number, bo: AuditCertificateBO) {
    return fetchAPI<AuditCertificateVO>(`${base}/update/${id}`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

export async function deleteById(id: number) {
    return fetchAPI<void>(`${base}/delete/${id}`, {method: 'POST'});
}

export const AuditCertificateService = {
    getById,
    queryPage,
    querySelectionList,
    create,
    update,
    deleteById,
};
